export const DELETE_PRODUCT_FROM_CART = 'DELETE_PRODUCT_FROM_CART';

export const deleteProductFromCart = (productId, optionId) => {
  return {
    type: DELETE_PRODUCT_FROM_CART,
    payload: { productId, optionId },
  };
};
